function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { createVNode as _createVNode } from "vue";
import { ref, watch, computed, reactive, defineComponent } from "vue";
import { extend, isHidden, unitToPx, numericProp, getScrollTop, getZIndexStyle, makeStringProp, makeNumericProp, createNamespace } from "../utils";
import { useRect, useEventListener, useScrollParent } from "@vant/use";
import { useVisibilityChange } from "../composables/use-visibility-change";

var _createNamespace = createNamespace("sticky"),
    _createNamespace2 = _slicedToArray(_createNamespace, 2),
    name = _createNamespace2[0],
    bem = _createNamespace2[1];

var stickyProps = {
  zIndex: numericProp,
  position: makeStringProp("top"),
  container: Object,
  offsetTop: makeNumericProp(0),
  offsetBottom: makeNumericProp(0)
};
var stdin_default = defineComponent({
  name: name,
  props: stickyProps,
  emits: ["scroll", "change"],
  setup: function setup(props, _ref) {
    var emit = _ref.emit,
        slots = _ref.slots;
    var root = ref();
    var scrollParent = useScrollParent(root);
    var state = reactive({
      fixed: false,
      width: 0,
      height: 0,
      transform: 0
    });
    var offset = computed(function () {
      return unitToPx(props.position === "top" ? props.offsetTop : props.offsetBottom);
    });
    var rootStyle = computed(function () {
      var fixed = state.fixed,
          height = state.height,
          width = state.width;

      if (fixed) {
        return {
          width: "".concat(width, "px"),
          height: "".concat(height, "px")
        };
      }
    });
    var stickyStyle = computed(function () {
      if (!state.fixed) {
        return;
      }

      var style = extend(getZIndexStyle(props.zIndex), _defineProperty({
        width: "".concat(state.width, "px"),
        height: "".concat(state.height, "px")
      }, props.position, "".concat(offset.value, "px")));

      if (state.transform) {
        style.transform = "translate3d(0, ".concat(state.transform, "px, 0)");
      }

      return style;
    });

    var emitScroll = function emitScroll(scrollTop) {
      return emit("scroll", {
        scrollTop: scrollTop,
        isFixed: state.fixed
      });
    };

    var onScroll = function onScroll() {
      if (!root.value || isHidden(root)) {
        return;
      }

      var container = props.container,
          position = props.position;
      var rootRect = useRect(root);
      var scrollTop = getScrollTop(window);
      state.width = rootRect.width;
      state.height = rootRect.height;

      if (position === "top") {
        if (container) {
          var containerRect = useRect(container);
          var difference = containerRect.bottom - offset.value - state.height;
          state.fixed = offset.value > rootRect.top && containerRect.bottom > 0;
          state.transform = difference < 0 ? difference : 0;
        } else {
          state.fixed = offset.value > rootRect.top;
        }
      } else {
        var clientHeight = document.documentElement.clientHeight;

        if (container) {
          var _containerRect = useRect(container);

          var _difference = clientHeight - _containerRect.top - offset.value - state.height;

          state.fixed = clientHeight - offset.value < rootRect.bottom && clientHeight > _containerRect.top;
          state.transform = _difference < 0 ? -_difference : 0;
        } else {
          state.fixed = clientHeight - offset.value < rootRect.bottom;
        }
      }

      emitScroll(scrollTop);
    };

    watch(function () {
      return state.fixed;
    }, function (value) {
      return emit("change", value);
    });
    useEventListener("scroll", onScroll, {
      target: scrollParent
    });
    useVisibilityChange(root, onScroll);
    return function () {
      var _a;

      return _createVNode("div", {
        "ref": root,
        "style": rootStyle.value
      }, [_createVNode("div", {
        "class": bem({
          fixed: state.fixed
        }),
        "style": stickyStyle.value
      }, [(_a = slots["default"]) == null ? void 0 : _a.call(slots)])]);
    };
  }
});
export { stdin_default as default };